module.exports = __webpack_public_path__ + "img/66.9fddf615.png";